<template>
  <div>
    <NuxtLink :to="localePathByType('ShopProductRecord', data.slug as string)">
      <div class="flex items-center justify-center rounded-3xl bg-white lg:h-96">
        <Image
          class="w-full object-cover px-3 py-10 lg:px-6 lg:py-6"
          loading="lazy"
          :src="data.images[0].url"
          :alt="data.images[0].alt"
          :width="data.responsiveImage?.width ? data.responsiveImage?.width : data.images[0].width"
          :height="
            data.responsiveImage?.height ? data.responsiveImage?.height : data.images[0].height
          "
          :sizes="data.responsiveImage?.sizes ? data.responsiveImage?.sizes : undefined"
        ></Image>
      </div>
    </NuxtLink>
    <div v-if="data.price" class="my-3 flex flex-row justify-start lg:my-6">
      <span class="hidden text-xl font-semibold text-blue-950 lg:block"> {{ data.price }} €</span>
    </div>
    <NuxtLink :to="localePathByType('ShopProductRecord', data.slug as string)">
      <div class="my-3 text-xl font-normal text-blue-950 lg:my-6">{{ data.title }}</div>
    </NuxtLink>

    <div v-if="data.price" class="pt-2 text-xl font-semibold text-blue-950 lg:hidden">
      {{ data.price }} €
    </div>
  </div>
</template>

<script lang="ts" setup>
const { localePathByType } = useLocalePathByType()

defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => ({})
  }
})
</script>
